/* useStableValue.ts */
import { useRef } from 'react';

/**
 * Returns the previous value if `isEqual(previous, next)` holds, so a
 * memoized computation that recreates a new object identity on every
 * dependency change (e.g. a Context Provider's `value`) doesn't force its
 * consumers to re-render when the fields they actually read didn't change.
 */
export default function useStableValue<T>(
  next: T,
  isEqual: (a: T, b: T) => boolean
): T {
  const ref = useRef(next);
  if (!isEqual(ref.current, next)) {
    ref.current = next;
  }
  return ref.current;
}
